import { LargeCard } from '../../Components/Cards/LargeCard';
import {
	get,
	post,
	put,
	deleteRequest,
	deleteRequestV2,
} from '../../api/usersModule/httpClient';
import { useEffect, useState } from 'react';
import { CDBModal } from 'cdbreact';
import { ModalUsers } from '../../Components/Modals/ModalUsers';
import { ModalUserProjects } from '../Modals/ModalUserProjects';
import swal from 'sweetalert';
import { getUserIDByEmailnReturn } from '../../api/usersModule/getters';
import { getRoleIDByName } from '../../api/usersModule/getters';
import { useDebounce } from '../../hooks/useDebounce';
import Select from "react-select";
import axios from 'axios';
import Swal from 'sweetalert2';

const usersheaders = ['Id', 'Nombre', 'Email', 'Telefono', 'Ciudad', 'Fecha de modificación'];
const defaultFormData = {
	UserID: '',
	UserName: '',
	UserEmail: '',
	UserPhone: '',
	UserCity: '',
	UserRole: '',
	UserPhoneAdd: '',
	UserCitySimple: '',
	Nit: '',
};

const PoolID = 'us-east-1_Z3h6lkdFJ';
const ClientID = '771qni77qtkgjbjiebjuqfnij9';

export const CrudUsers = ({ userName, permissions, project, change }) => {
	const [data, setData] = useState([]);
	const [state, setState] = useState({ modal1: false });
	const [page, setPage] = useState(1);
	const [totalItems, setTotalItems] = useState(0);
	const [pressedButton, setPressedButton] = useState('');
	const [action, setAction] = useState('');
	const [formData, setFormData] = useState(defaultFormData);
	const [search, setSearch] = useState('');
	const [changePage, setChangePage] = useState(false);
	const debouncedSearch = useDebounce(search, 500);
	const [initialRender, setInitialRender] = useState(true);
	const [itemsPerPage, setItemsPerPage] = useState(5);
	//Loading Modal
	const [isLoading, setIsLoading] = useState(false);

	//Loading carga de datos inicial
	const [loading, setLoading] = useState(true);

	//Crea un nuevo estado para almacenar el valor del select
	const [selectedProject, setSelectedProject] = useState('');
	const [projects, setProjects] = useState([]);
	//Crea una función para obtener los proyectos del backend
	const getProjects = async () => {
		const projects = await get(`/projects?Nit=${project}&list=${true}`);
		const providerSelect = projects.items.map((project) => ({
		  value: project.Nit,
		  label: project.ProjectName,
		}));
		setSelectedProject((providerSelect.length > 0 ? providerSelect[0].value : ''))
		return providerSelect;
	};	  
	//Crea una función para obtener los usuarios relacionados a un Nit
	const getUsersByProjectID = async (Nit) => {
		const users = await get(`/users?Nit=${Nit}`);
		if (users.answer) {
			setTotalItems(users.pagination.totalItems);  
		} else {
			setTotalItems(0);
		}
		return users.items;
	};
	//En el useEffect, llama a la función getProjects para obtener los proyectos del backend y almacenarlos en el estado projects
	useEffect(() => {
		getProjects(project).then((projects) => setProjects(projects));
	}, []);

	useEffect(() => {
		if (selectedProject) {
			getUsersByProjectID(selectedProject).then((users) => setData(users));
		}
	}, [selectedProject]);



	const getData = async (search, statusPage) => {
		setLoading(true);

		let localProject = selectedProject ? selectedProject : project;

		const data = await get(
			`/users?page=${statusPage}&search=${search}&Nit=${localProject}&limit=${itemsPerPage}`
		);

		if (data.answer) {
			setTotalItems(data.pagination.totalItems);  
		} else {
			setTotalItems(0);
		}
		setData(data.items);
		setLoading(false);
	};

	const getUser = async (id) => {
		let localProject = selectedProject ? selectedProject : project;
		const data = await get(`/users?userID=${id}&Nit=${localProject}`);
		
		const [ciudad, departamento] = data.items[0].UserCity.split(',');
		const [indicativo, celular] = data.items[0].UserPhone.split('-');
		setFormData({
			UserID: data.items[0].UserID,
			UserName: data.items[0].UserName,
			UserEmail: data.items[0].UserEmail,
			UserPhone: celular,
			UserCity: ciudad,
			UserDepartment: departamento,
			UserCountryCode: indicativo,
			Nit: data.items[0].Nit,
		});
		toggle(6)();
	};			  

	const convertDataToArray = () => {
		try {
		  return data.map((item) => {
			const city = item.UserCity.split(',')[0];
			return [
			  item.UserID,
			  item.UserName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '),
			  item.UserEmail.toLowerCase(),
			  item.UserPhone,
			  city,
			  item.ModificationDate,
			];
		  });
		} catch (error) {
		  console.error(error);
		  return [];
		}
	};		  

	const toggle = (nr) => () => {
		let modalNumber = 'modal' + nr;
		setState({
			...state,
			[modalNumber]: !state[modalNumber],
		});

	};

	const handleChange = (targets) => {
		targets.forEach((target) => {
			const { id, value } = target;
			setFormData((prevData) => ({ ...prevData, [id]: value }));
		});
	};

	const handleSelect = async (e) => {
		setFormData({
			...formData,
			[e.id]: e.value,
		});
	};

	const handleSubmit = async () => {

		//If some field is empty, show error
		setIsLoading(true);
		if (
			formData.UserName === '' ||
			formData.UserEmail === '' ||
			formData.UserPhone === '' ||
			formData.UserCity === ''
		) {
			swal('Error', 'Por favor, rellene todos los campos', 'error');
			setIsLoading(false);
			return;
		} else {
			const regex = /^\+[0-9]{1,3}[0-9]{10}$/;
			if (!regex.test(formData.UserCountryCode + "" + formData.UserPhone)) {
				setIsLoading(false);
				swal(
					'Error',
					'El número de teléfono no es válido, debe tener la forma +57xxxxxxxxxx',
					'error'
				);
			} else {
				const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
				if (!emailRegex.test(formData.UserEmail)) {
					setIsLoading(false);
					swal('Error', 'El correo electrónico no es válido', 'error');
				} else {
					const passwordRegex =
					/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&+])([A-Za-z\d$@$!%*?&+]|[^ ]){8,}$/;
					if (!passwordRegex.test(formData.UserPassword) && action !== 'edit') {
						setIsLoading(false);
						swal(
							'Error',
							'La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un caracter especial ($, @, !, %, *, ?, &, +).',
							'error'
						);
					} else {
						Swal.fire({
							title: `${action === "create" ? 'Creando' : 'Actualizando'} Usuario`,
							text: 'Por favor, espere...',
							icon: 'info',
							allowOutsideClick: false,
							showCancelButton: false,
							showConfirmButton: false,
							willOpen: () => {
								Swal.showLoading();
							},
						});

						if (action === 'create') {
							if (formData.UserRole === '') {
								setIsLoading(false);
								swal(
									'Error',
									'Por favor seleccione un rol. Si no aparece ninguno o no puede editar, verifique los roles estén activos',
									'error'
								);
							} else {
								let localProject = selectedProject ? selectedProject : project;
						
								delete formData.UserID;
								const userRole = await getRoleIDByName(formData.UserRole, project);
						
								const info = {
									name: formData.UserName.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '),
									city: formData.UserCity + "," + formData.UserDepartment,
									password: formData.UserPassword,
									phone: formData.UserCountryCode + "-" + formData.UserPhone,
									clientid: ClientID, //cambiar
									email: formData.UserEmail.toLowerCase(),
									userpool: PoolID,
									Nit: localProject,
								};
						
								const res = await post('/users', info);
						
								if (res.answer === false && res.message === 'El usuario ya existe con ese correo electrónico.') {
									setIsLoading(false);
									swal(
										'Error',
										'El usuario ya existe con ese correo electrónico.',
										'error'
									);
									Swal.close();
								} else if (res.name === 'AxiosError') {
									setIsLoading(false);
									Swal.close();
								} else {
									// Aquí solo se ejecuta si el usuario se ha creado correctamente
									const createdUserID = await getUserIDByEmailnReturn(
										formData.UserEmail,
										localProject
									);
									const info2 = {
										Nit: 1,
										roleID: userRole,
										userID: createdUserID,
										user: userName ? userName : '',
									};
						
									await post('/projectsRolesUsers', info2);
									setIsLoading(false);
									Swal.close();
									toggle(6)();
									getData('', 1);
								}
								Swal.close();
							}
						} else {
							formData.UserPhoneAdd = formData.UserCountryCode + "-" + formData.UserPhone
							formData.UserCitySimple = formData.UserCity + "," + formData.UserDepartment
							await axios.put(
								'https:///8siu8hczc2.execute-api.us-east-1.amazonaws.com/Prod/users',
								formData
							).then((response) => {
								if (response.status === 200) {
									toggle(6)();
									swal('Usuario Actualizado', 'La información del usuario ha sido actualizada', 'success');
								} else {
									swal('Error', 'Ha ocurrido un error', 'error');
								}
							});

							Swal.close();

							getData('', 1);
						}
					}
				}
			}
		}
		setIsLoading(false);
	};

	const deleteUser = async () => {
		const body = {
			UserID: formData.UserID,
			UserPool: PoolID, //cambiar
			UserEmail: formData.UserEmail,
		};

		const confirmDelete = await Swal.fire({
			title: 'Confirmar Eliminación del Usuario',
			text: 'Esta acción eliminará de manera permanente el Usuario seleccionado. ¿Está seguro de que desea proceder?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#146284',
			cancelButtonColor: '#EF4444',
			confirmButtonText: 'Sí, eliminar',
			cancelButtonText: 'Cancelar',
		});

		if (confirmDelete.isConfirmed) {

			Swal.fire({
				title: 'Eliminando Usuario',
				text: 'Por favor, espere...',
				icon: 'info',
				allowOutsideClick: false,
				showCancelButton: false,
				showConfirmButton: false,
				willOpen: () => {
					Swal.showLoading();
				},
			});

			await deleteRequestV2('/users', body, true);

			Swal.close();

			toggle(6)();
			getData('', 1);
		}
	};

	useEffect(() => {
		if (initialRender) {
			setInitialRender(false);
			return;
		}
		
		if (!changePage) {
			getData(debouncedSearch, page);
		}else {
			setChangePage(false)
		}
	}, [page, initialRender]);

	useEffect(() => {
		getData(debouncedSearch, 1);
		setChangePage(true);
    	setPage(1)
	}, [debouncedSearch]);

	useEffect(() => {
		getData(debouncedSearch, 1);
		setChangePage(true);
    	setPage(1)
	}, [itemsPerPage]);

	useEffect(() => {
		getProjects(project).then((projects) => setProjects(projects));
	}, [change]);

	useEffect(() => {
		switch (pressedButton.split(',')[0]) {
			case 'create':
				if (permissions['Crear']) {
					setAction('create');
					setFormData(defaultFormData);
					toggle(6)();
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para crear usuarios',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'edit':
				if (permissions['Editar']) {
					setAction('edit');
					getUser(pressedButton.split(',')[1]);
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para editar usuarios',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'delete':
				if (permissions['Eliminar']) {
					deleteUser();
				} else {
					swal({
						title: 'Error',
						text: 'No tiene permisos para borrar usuarios',
						icon: 'error',
						buttons: ['', 'Aceptar'],
					});
				}
				break;
			case 'refresh':
				setData(['']);
				//getData('');
				getData('', page);
				break;
			case 'closeModal':
				toggle(6)();
				break;
			case 'submitModal':
				handleSubmit();
				break;
			case 'projects':
				setState({
					...state,
					modal6: false,
					modal1: true,
				});
				break;
			default:
				break;
		}
		setPressedButton('');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pressedButton]);

	return (
		<>
			<h4>Selecciona un proveedor para gestionar sus usuarios:</h4>
			<Select
				id="Nit"
				placeholder="Nombre del proveedor"
				options={projects}
				value={projects.find((option) => option.value === selectedProject)}
				onChange={(selectedOption) => setSelectedProject(selectedOption.value)}
			/>
			<LargeCard
				name='Usuarios'
				icon='fas fa-users'
				headers={usersheaders}
				loading={loading}
				data={convertDataToArray()}
				totalItems={totalItems}
				setPage={setPage}
				page={page}
				setChangePage={setChangePage}
				customTable={false}
				setPressedButton={setPressedButton}
				setSearch={setSearch}
				cState={true}
				itemsPerPage={itemsPerPage}
        		setItemsPerPage={setItemsPerPage}
			/>

			<CDBModal isOpen={state.modal6} toggle={toggle(6)}>
				<ModalUsers
					action={action}
					setPressedButton={setPressedButton}
					formData={formData}
					handleChange={handleChange}
					isLoading={isLoading}
					handleSelect={handleSelect}
					project={project}
				/>
			</CDBModal>

			<CDBModal isOpen={state.modal1} toggle={toggle(1)}>
				<ModalUserProjects
					UserName={formData.UserName}
					UserID={formData.UserID}
					setPressedButton={setPressedButton}
					project={project}
				/>
			</CDBModal>
		</>
	);
};